import React from 'react';
import { ConfigProvider } from 'antd';
import { useLanguage } from '@app/hooks/useLanguage';
import { WithChildrenProps } from '@app/types/generalTypes';
import { resolveAntdLocale } from './antdLocale';

export const AppAntdProvider: React.FC<WithChildrenProps> = ({ children }) => {
  const { language } = useLanguage();

  return (
    <ConfigProvider locale={resolveAntdLocale(language)}>
      {children}
    </ConfigProvider>
  );
};
